import React, { useEffect, useRef, useState } from 'react';
import taskService from 'services/http/task-service';
import utils, { CUSTOM_MESSAGES } from 'utils';
import { SkeletonLoader, CustomAutoComplete, CustomButton, ToastNotification } from 'components/shared';
import { WilayaDropdownHoc } from 'components/pages/client-management/client-info-edit';
import $ from "jquery";

export const TaskEnclose = (props) => {

    const [selectedTags, setSelectedTags] = useState([]);
    const [filtredTags, setFiltredTags] = useState();
    const [allTags, setAllTags] = useState();
    const [wilaya, setWilaya] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingSubmission, setLoadingSubmission] = useState(false);
    const toastRef = useRef();

    const searchTag = (e) => {
        setTimeout(() => {
            let _filtredTags;
            if (!e.query.trim().length) {
                _filtredTags = [...allTags];
            }
            else {
                _filtredTags = allTags.filter((tag) => {
                    return tag.toLowerCase().includes(e.query.toLowerCase());
                });
            }
            setFiltredTags(_filtredTags);
        }, 250);
    }

    useEffect(() => {
        setLoading(true);
        taskService.getTags(``).then((response) => {
            setAllTags(response.result.map((item) => { return item.description }));
        }, error => {
            alert(error);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const onSubmit = () => {
        let tags = [];
        selectedTags.filter((item) => item).map((item) => {
            tags.push({ description: item });
            return item;
        });
        if (tags.length) {
            setLoadingSubmission(true);
            taskService.updatetaskStatus({
                taskId: props.task.id,
                status: props.task.status,
                view: props.view,
                wilaya: wilaya?.wilayaId,
                payload: tags
            }).then(response => {
                props.successCallback(response.message);
            }, error => {
                props.errorCallback(error);
            }).finally(() => {
                setLoadingSubmission(false);
            });
        } else {
            props.errorCallback(CUSTOM_MESSAGES.NO_ITEM_SELECTED);
        }

    }

    return (
        <div className="task-enclose-layout">
            {
                loading ? <SkeletonLoader factor={1} /> :
                    <div>
                        <h6 className="text-center">Categorize the task by custom tags</h6>
                        <CustomAutoComplete
                            id="tags-autocomplete"
                            className="appender-dropdown"
                            value={selectedTags}
                            suggestions={filtredTags}
                            completeMethod={searchTag}
                            placeholder="Tags"
                            multiple
                            dropdown
                            light
                            onDropdownClick={() => {
                                utils.assignHeightToElement(".task-enclose-layout", 150);
                            }}
                            scrollHeight={filtredTags?.length > 3 ? "100px" : "fit-content"}
                            icon="bi bi-tags"
                            onChange={(e) => { setSelectedTags(e.value); }}
                        />

                        <div className="my-2">
                            <WilayaDropdownHoc
                                value={wilaya}
                                icon="bi bi-geo-alt"
                                onFocus={(e) => { e.preventDefault(); $(".task-action-modal").css("height", "18rem") }} 
                                callbackFn={(payload) => {
                                    setWilaya(payload); 
                                }} />
                        </div>

                        <div className="my-3 text-center">
                            <CustomButton
                                label={utils.labelTemplate(<><i className="bi bi-check-circle" /> Submit</>, loadingSubmission, "Processing...")}
                                style={{ width: "60%" }}
                                className={loadingSubmission && "not-allowed"}
                                onClick={(e) => { onSubmit(e) }} />
                        </div>
                    </div>
            }
            <ToastNotification ref={toastRef} />

        </div>
    );
}